import React from 'react'

export default function Folds({ symmetry, onSymmetryChange }) {
    const handleSymmetry = (p) => {
        if (p === 'down') {
            onSymmetryChange(symmetry=symmetry+1)
        } else {
            onSymmetryChange(symmetry=symmetry-1)
        }
    }
  
  return (
    <div className="mb-4 flex">
        <span className='label'>Symmetry</span>
        {symmetry < 4 ? ' ' : <button onClick={() => {handleSymmetry('up')}} className='bg-green-500 hover:bg-darkgreen-700 text-white font-bold py-2 px-2 mx-2 rounded'>-</button>}
        <span className='label'>{symmetry}</span>
        {symmetry > 9 ? ' ' : <button onClick={() => {handleSymmetry('down')}} className='bg-green-500 hover:bg-darkgreen-700 text-white font-bold py-2 px-2 rounded'>+</button>}
        
    </div>

  )
}
